"use strict";

var _excluded = ["theme", "css", "__css", "sx"],
    _excluded2 = ["baseStyle"],
    _excluded3 = ["styleConfig"],
    _excluded4 = ["baseConfig"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __reExport = function __reExport(target, mod, secondTarget) {
  return __copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default");
};

var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps( // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  CSSVars: function CSSVars() {
    return _CSSVars;
  },
  GlobalStyle: function GlobalStyle() {
    return _GlobalStyle;
  },
  StylesProvider: function StylesProvider() {
    return _StylesProvider;
  },
  ThemeProvider: function ThemeProvider() {
    return _ThemeProvider;
  },
  chakra: function chakra() {
    return _chakra;
  },
  createStylesContext: function createStylesContext() {
    return _createStylesContext;
  },
  forwardRef: function forwardRef() {
    return _forwardRef;
  },
  getToken: function getToken() {
    return _getToken;
  },
  keyframes: function keyframes() {
    return import_react8.keyframes;
  },
  shouldForwardProp: function shouldForwardProp() {
    return _shouldForwardProp;
  },
  styled: function styled() {
    return _styled;
  },
  toCSSObject: function toCSSObject() {
    return _toCSSObject;
  },
  useChakra: function useChakra() {
    return _useChakra;
  },
  useComponentStyles__unstable: function useComponentStyles__unstable() {
    return _useComponentStyles__unstable;
  },
  useMultiStyleConfig: function useMultiStyleConfig() {
    return _useMultiStyleConfig;
  },
  useStyleConfig: function useStyleConfig() {
    return _useStyleConfig;
  },
  useStyles: function useStyles() {
    return _useStyles;
  },
  useTheme: function useTheme() {
    return _useTheme;
  },
  useToken: function useToken() {
    return _useToken;
  }
});

module.exports = __toCommonJS(src_exports);

__reExport(src_exports, require("@chakra-ui/color-mode"), module.exports);

__reExport(src_exports, require("@chakra-ui/styled-system"), module.exports);

var import_react8 = require("@emotion/react"); // src/hooks.ts


var import_color_mode = require("@chakra-ui/color-mode"); // src/use-theme.ts


var import_react = require("@emotion/react");

var import_react2 = require("react");

function _useTheme() {
  var theme = (0, import_react2.useContext)(import_react.ThemeContext);

  if (!theme) {
    throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");
  }

  return theme;
} // src/hooks.ts


function _useChakra() {
  var colorModeResult = (0, import_color_mode.useColorMode)();

  var theme = _useTheme();

  return _objectSpread(_objectSpread({}, colorModeResult), {}, {
    theme: theme
  });
}

function getBreakpointValue(theme, value, fallback) {
  var _a2, _b;

  if (value == null) return value;

  var getValue = function getValue(val) {
    var _a3, _b2;

    return (_b2 = (_a3 = theme.__breakpoints) == null ? void 0 : _a3.asArray) == null ? void 0 : _b2[val];
  };

  return (_b = (_a2 = getValue(value)) != null ? _a2 : getValue(fallback)) != null ? _b : fallback;
}

function getTokenValue(theme, value, fallback) {
  var _a2, _b;

  if (value == null) return value;

  var getValue = function getValue(val) {
    var _a3, _b2;

    return (_b2 = (_a3 = theme.__cssMap) == null ? void 0 : _a3[val]) == null ? void 0 : _b2.value;
  };

  return (_b = (_a2 = getValue(value)) != null ? _a2 : getValue(fallback)) != null ? _b : fallback;
}

function _useToken(scale, token, fallback) {
  var theme = _useTheme();

  return _getToken(scale, token, fallback)(theme);
}

function _getToken(scale, token, fallback) {
  var _token = Array.isArray(token) ? token : [token];

  var _fallback = Array.isArray(fallback) ? fallback : [fallback];

  return function (theme) {
    var fallbackArr = _fallback.filter(Boolean);

    var result = _token.map(function (token2, index) {
      var _a2, _b;

      if (scale === "breakpoints") {
        return getBreakpointValue(theme, token2, (_a2 = fallbackArr[index]) != null ? _a2 : token2);
      }

      var path = "".concat(scale, ".").concat(token2);
      return getTokenValue(theme, path, (_b = fallbackArr[index]) != null ? _b : token2);
    });

    return Array.isArray(token) ? result : result[0];
  };
} // src/providers.tsx


var import_color_mode2 = require("@chakra-ui/color-mode");

var import_react_utils = require("@chakra-ui/react-utils");

var import_styled_system = require("@chakra-ui/styled-system");

var import_utils = require("@chakra-ui/utils");

var import_react3 = require("@emotion/react");

var import_react4 = require("react");

var import_jsx_runtime = require("react/jsx-runtime");

function _ThemeProvider(props) {
  var cssVarsRoot = props.cssVarsRoot,
      theme = props.theme,
      children = props.children;
  var computedTheme = (0, import_react4.useMemo)(function () {
    return (0, import_styled_system.toCSSVar)(theme);
  }, [theme]);
  return /* @__PURE__ */(0, import_jsx_runtime.jsxs)(import_react3.ThemeProvider, {
    theme: computedTheme,
    children: [/* @__PURE__ */(0, import_jsx_runtime.jsx)(_CSSVars, {
      root: cssVarsRoot
    }), children]
  });
}

function _CSSVars(_ref) {
  var _ref$root = _ref.root,
      root = _ref$root === void 0 ? ":host, :root" : _ref$root;
  var selector = [root, "[data-theme]"].join(",");
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react3.Global, {
    styles: function styles(theme) {
      return _defineProperty({}, selector, theme.__cssVars);
    }
  });
}

var _ref3 = (0, import_react_utils.createContext)({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
}),
    _ref4 = _slicedToArray(_ref3, 2),
    _StylesProvider = _ref4[0],
    _useStyles = _ref4[1];

function _createStylesContext(componentName) {
  return (0, import_react_utils.createContext)({
    name: "".concat(componentName, "StylesContext"),
    errorMessage: "useStyles: \"styles\" is undefined. Seems you forgot to wrap the components in \"<".concat(componentName, " />\" ")
  });
}

function _GlobalStyle() {
  var _ref5 = (0, import_color_mode2.useColorMode)(),
      colorMode = _ref5.colorMode;

  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react3.Global, {
    styles: function styles(theme) {
      var styleObjectOrFn = (0, import_utils.memoizedGet)(theme, "styles.global");
      var globalStyles = (0, import_utils.runIfFn)(styleObjectOrFn, {
        theme: theme,
        colorMode: colorMode
      });
      if (!globalStyles) return void 0;
      var styles = (0, import_styled_system.css)(globalStyles)(theme);
      return styles;
    }
  });
} // src/system.ts


var import_color_mode3 = require("@chakra-ui/color-mode");

var import_styled_system3 = require("@chakra-ui/styled-system");

var import_utils2 = require("@chakra-ui/utils");

var import_object_utils = require("@chakra-ui/object-utils");

var import_styled = __toESM(require("@emotion/styled"));

var import_react5 = __toESM(require("react")); // src/should-forward-prop.ts


var import_styled_system2 = require("@chakra-ui/styled-system");

var allPropNames = /* @__PURE__ */new Set([].concat(_toConsumableArray(import_styled_system2.propNames), ["textStyle", "layerStyle", "apply", "noOfLines", "focusBorderColor", "errorBorderColor", "as", "__css", "css", "sx"]));
var validHTMLProps = /* @__PURE__ */new Set(["htmlWidth", "htmlHeight", "htmlSize", "htmlTranslate"]);

function _shouldForwardProp(prop) {
  return validHTMLProps.has(prop) || !allPropNames.has(prop);
} // src/system.ts


var _a;

var emotion_styled = (_a = import_styled.default.default) != null ? _a : import_styled.default;

var _toCSSObject = function _toCSSObject(_ref6) {
  var baseStyle = _ref6.baseStyle;
  return function (props) {
    var theme = props.theme,
        cssProp = props.css,
        __css = props.__css,
        sx = props.sx,
        rest = _objectWithoutProperties(props, _excluded);

    var styleProps = (0, import_utils2.objectFilter)(rest, function (_, prop) {
      return (0, import_styled_system3.isStyleProp)(prop);
    });
    var finalBaseStyle = (0, import_utils2.runIfFn)(baseStyle, props);
    var finalStyles = (0, import_object_utils.assignAfter)({}, __css, finalBaseStyle, (0, import_utils2.filterUndefined)(styleProps), sx);
    var computedCSS = (0, import_styled_system3.css)(finalStyles)(props.theme);
    return cssProp ? [computedCSS, cssProp] : computedCSS;
  };
};

function _styled(component, options) {
  var _ref7 = options != null ? options : {},
      baseStyle = _ref7.baseStyle,
      styledOptions = _objectWithoutProperties(_ref7, _excluded2);

  if (!styledOptions.shouldForwardProp) {
    styledOptions.shouldForwardProp = _shouldForwardProp;
  }

  var styleObject = _toCSSObject({
    baseStyle: baseStyle
  });

  var Component = emotion_styled(component, styledOptions)(styleObject);
  var chakraComponent = import_react5.default.forwardRef(function ChakraComponent(props, ref) {
    var _ref8 = (0, import_color_mode3.useColorMode)(),
        colorMode = _ref8.colorMode,
        forced = _ref8.forced;

    return import_react5.default.createElement(Component, _objectSpread({
      ref: ref,
      "data-theme": forced ? colorMode : void 0
    }, props));
  });
  return chakraComponent;
} // src/forward-ref.tsx


var import_react6 = require("react");

function _forwardRef(component) {
  return (0, import_react6.forwardRef)(component);
} // src/use-style-config.ts


var import_styled_system4 = require("@chakra-ui/styled-system");

var import_theme_utils = require("@chakra-ui/theme-utils");

var import_utils3 = require("@chakra-ui/utils");

var import_react7 = require("react");

var import_react_fast_compare = __toESM(require("react-fast-compare"));

function useStyleConfigImpl(themeKey) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _a2;

  var styleConfigProp = props.styleConfig,
      rest = _objectWithoutProperties(props, _excluded3);

  var _useChakra2 = _useChakra(),
      theme = _useChakra2.theme,
      colorMode = _useChakra2.colorMode;

  var themeStyleConfig = themeKey ? (0, import_utils3.memoizedGet)(theme, "components.".concat(themeKey)) : void 0;
  var styleConfig = styleConfigProp || themeStyleConfig;
  var mergedProps = (0, import_utils3.mergeWith)({
    theme: theme,
    colorMode: colorMode
  }, (_a2 = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _a2 : {}, (0, import_utils3.filterUndefined)((0, import_utils3.omit)(rest, ["children"])));
  var stylesRef = (0, import_react7.useRef)({});

  if (styleConfig) {
    var getStyles = (0, import_styled_system4.resolveStyleConfig)(styleConfig);
    var styles = getStyles(mergedProps);
    var isStyleEqual = (0, import_react_fast_compare.default)(stylesRef.current, styles);

    if (!isStyleEqual) {
      stylesRef.current = styles;
    }
  }

  return stylesRef.current;
}

function _useStyleConfig(themeKey) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return useStyleConfigImpl(themeKey, props);
}

function _useMultiStyleConfig(themeKey) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return useStyleConfigImpl(themeKey, props);
}

function _useComponentStyles__unstable(themeKey, props) {
  var _a2;

  var baseConfig = props.baseConfig,
      restProps = _objectWithoutProperties(props, _excluded4);

  var _useChakra3 = _useChakra(),
      theme = _useChakra3.theme;

  var overrides = (_a2 = theme.components) == null ? void 0 : _a2[themeKey];
  var styleConfig = overrides ? (0, import_theme_utils.mergeThemeOverride)(overrides, baseConfig) : baseConfig;
  return useStyleConfigImpl(null, _objectSpread(_objectSpread({}, restProps), {}, {
    styleConfig: styleConfig
  }));
} // src/factory.ts


function factory() {
  var cache = /* @__PURE__ */new Map();
  return new Proxy(_styled, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply: function apply(target, thisArg, argArray) {
      return _styled.apply(void 0, _toConsumableArray(argArray));
    },

    /**
     * @example
     * <chakra.div />
     */
    get: function get(_, element) {
      if (!cache.has(element)) {
        cache.set(element, _styled(element));
      }

      return cache.get(element);
    }
  });
}

var _chakra = factory(); // Annotate the CommonJS export names for ESM import in node:


0 && (module.exports = _objectSpread(_objectSpread({
  CSSVars: _CSSVars,
  GlobalStyle: _GlobalStyle,
  StylesProvider: _StylesProvider,
  ThemeProvider: _ThemeProvider,
  chakra: _chakra,
  createStylesContext: _createStylesContext,
  forwardRef: _forwardRef,
  getToken: _getToken,
  keyframes: keyframes,
  shouldForwardProp: _shouldForwardProp,
  styled: _styled,
  toCSSObject: _toCSSObject,
  useChakra: _useChakra,
  useComponentStyles__unstable: _useComponentStyles__unstable,
  useMultiStyleConfig: _useMultiStyleConfig,
  useStyleConfig: _useStyleConfig,
  useStyles: _useStyles,
  useTheme: _useTheme,
  useToken: _useToken
}, require("@chakra-ui/color-mode")), require("@chakra-ui/styled-system")));